const Link = {
    Bdc: 'https://bdc4.yingxiong.com', // BDC 运营数据平台
    Gms: 'https://gms.yingxiong.com', // GMS 客服查询平台
    Ad_Tracking:'https://adstrack.yingxiong.com', // Ad Tracking 广告监测平台
    Ad_Desk_New: 'https://adsmartech.yingxiong.com', // Ad Desk 广告投放平台
    Ds_Platform: 'https://open.yingxiong.com/index.html#/user/welcome?token=x', // DS Platform 发行服务平台
    Hfs: 'https://hfs.yingxiong.com', // HFS 财务结算系统备份
    Usdk: 'https://auth.yingxiong.com/login?service=http%3A%2F%2Fopen.yingxiong.com%2Fsso%2Flogin', // USDK 融合SDK
    Csdk: 'https://auth.yingxiong.com/login?service=http%3A%2F%2Fopen.yingxiong.com%2Fsso%2Flogin', // CSDK 聊天SDK
    Arts: 'https://file-bdc.yingxiong.com', // Arts Center 美术平台
    Jira: 'https://jira.at.yingxiong.com', // Jira 项目管理平台
    Confluence: 'https://cf.at.yingxiong.com', // Confluence 文档管理
    Confluence_join:'https://herogames.feishu.cn/wiki/wikcnO0buREvus63zXJH2IsKlVh',
    About_hero: 'https://www.yingxiong.com/about.html',
    Join_us: 'https://www.yingxiong.com/join.html',
    oa: 'https://oa.yingxiong.com',
    ehr: 'https://openapi.italent.cn/sso/ssocustom/verifylogin/pc/106996/yxhy/100',
    zp: 'https://app.mokahr.com/',
    nc: '',
    Df:"https://df-bdc.yingxiong.com",
    Nms:"https://nms-bdc.yingxiong.com",
    yinsi:"https://hbdc.yingxiong.com/#/yinsi",
    gmdc:"https://openapi-bdc.yingxiong.com",
    gmdp:"https://gmdp.yingxiong.com"
}

export default Link